import React from 'react';
import type { KpiViewMode } from './line-item-daily-kpis';

export function KpiViewToggle({
  viewMode,
  setViewMode
}: {
  viewMode: KpiViewMode;
  setViewMode: (mode: KpiViewMode) => void;
}) {
  return (
    <div className="flex flex-col items-center gap-1">
      <button
        type="button"
        className={`rounded px-1 py-0.5 text-xs font-medium transition-colors ${
          viewMode === 'delivery'
            ? 'bg-gray-800 text-white'
            : 'cursor-pointer text-gray-800 hover:bg-gray-100 hover:text-gray-600'
        }`}
        onClick={() => setViewMode('delivery')}>
        Daily delivery
      </button>
      <button
        type="button"
        className={`rounded px-1 py-0.5 text-xs font-medium transition-colors ${
          viewMode === 'spend'
            ? 'bg-gray-800 text-white'
            : 'cursor-pointer text-gray-800 hover:bg-gray-100 hover:text-gray-600'
        }`}
        onClick={() => setViewMode('spend')}>
        Daily spend
      </button>
    </div>
  );
}

export function KpiCard({ label, value }: { label: string; value: React.ReactNode }) {
  return (
    <div className="flex flex-1 flex-col gap-1">
      <span className="text-xs font-medium text-gray-600">{label}</span>
      <span className="min-h-[32px] flex items-center text-lg font-semibold text-gray-800">
        {value}
      </span>
    </div>
  );
}

export function KpiValueSkeleton() {
  return <div className="h-[26px] w-16 animate-pulse rounded bg-gray-200" />;
}
